import { PLAYSTORE_URL, APPSTORE_URL, PLAYSTORE_BUNDLE_ID, APPSTORE_ID } from "constants/appLinks"

const KSA_APP_BUNDLE_ID = "com.bayut.ksa"
const KSA_APP_SCHEME = "bayutksa"

export const isIOS = () => {
  return /iPhone|iPad|iPod/.test(navigator.userAgent)
}

export const isMobileBrowser = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isMacOS = () => {
  return /Macintosh|Mac OS X/.test(navigator.userAgent)
}

export const openAppStore = () => {
  window.open(APPSTORE_URL, "_blank")
}

export const openPlayStore = () => {
  window.open(PLAYSTORE_URL, "_blank")
}

export const openApp = () => {
  if (isMacOS()) {
    // For macOS, directly open the App Store
    openAppStore()
    return
  }

  if (isIOS()) {
    // Try to open the app with a specific URL scheme for KSA
    window.location.href = `${KSA_APP_SCHEME}://open`
  } else {
    // For Android, use direct intent URL with bundle ID from constants
    window.location.href = `intent://#Intent;scheme=${KSA_APP_SCHEME};package=${KSA_APP_BUNDLE_ID};end`
  }
}

export const checkAppInstalled = () => {
  return new Promise(resolve => {
    // For macOS, always return false to open the store
    if (isMacOS()) {
      resolve(false)
      return
    }

    let isResolved = false
    const startTime = Date.now()
    const timeout = 1500 // 1.5 seconds timeout

    const resolveOnce = value => {
      if (!isResolved) {
        isResolved = true
        resolve(value)
      }
    }

    // Handle visibility change
    const handleVisibilityChange = () => {
      if (document.hidden) {
        resolveOnce(true)
        document.removeEventListener("visibilitychange", handleVisibilityChange)
      }
    }

    // Handle blur event (app opened)
    const handleBlur = () => {
      resolveOnce(true)
      window.removeEventListener("blur", handleBlur)
    }

    // Handle focus event (app not installed)
    const handleFocus = () => {
      if (Date.now() - startTime > 100) {
        // Small delay to avoid false positives
        resolveOnce(false)
        window.removeEventListener("focus", handleFocus)
      }
    }

    // Set up event listeners
    document.addEventListener("visibilitychange", handleVisibilityChange)
    window.addEventListener("blur", handleBlur)
    window.addEventListener("focus", handleFocus)

    // Set timeout
    setTimeout(() => {
      resolveOnce(false)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      window.removeEventListener("blur", handleBlur)
      window.removeEventListener("focus", handleFocus)
    }, timeout)

    // Try to open the app
    openApp()
  })
}

export const openAppropriateStore = async () => {
  if (isMobileBrowser()) {
    try {
      const isInstalled = await checkAppInstalled()
      if (!isInstalled) {
        if (isIOS()) {
          openAppStore()
        } else {
          openPlayStore()
        }
      }
    } catch (error) {
      // If there's an error checking installation, open appropriate store
      if (isIOS()) {
        openAppStore()
      } else {
        openPlayStore()
      }
    }
  } else {
    // For desktop browsers, just open appropriate store
    if (isIOS()) {
      openAppStore()
    } else {
      openPlayStore()
    }
  }
}
